import jssVariables from "../../jss_setup";

export const lpMainSearchFormStyles = {
  mainSearchForm: {
    smallscreen: {
      padding: `calc(${jssVariables.normal_gap} * 1.5)`,
    },
  },
  SearchFormNavBar: {
    padding: [jssVariables.half_gap, 0],
    paddingBottom: jssVariables.half_gap,
    smallscreen: {
      padding: 0,
      paddingBottom: jssVariables.normal_gap,
    },
  },
  SearchFormNavBarContainer: {
    smallscreen: {
      paddingBottom: 0,
      gridTemplateColumns: "repeat(1, 1fr)",
    },
  },
  inputGroupField: {
    placeholder: {
      color: jssVariables.colors.border,
    },
    control: {
      borderRadius: 0,
      borderColor: "white!important",
      height: "3rem",

      smallscreen: {
        borderRadius: 0,
        borderColor: "white!important",
        height: "3rem",
      },
    },
    input: {
      borderRadius: 0,
    },
    paxBtn: {
      borderRadius: 0,
      border: "1px solid white",
    },
    reactSelectControl: {
      borderRadius: 0,
      borderColor: "white!important",
    },
    datepicker: {
      borderRadius: 0,
      borderColor: "white",
    },
  },
  transferSearchForm: {
    paddingTop: 0,
    smallscreen: {
      padding: 0,
    },
  },
  carRentalSearchForm: {
    paddingTop: 0,
    smallscreen: {
      padding: 0,
    },
  },
};

export const landingPageSplashStyles = {
  headerContainer: {
    gridGap: jssVariables.normal_gap,
    transform: "translate(-50%, 0%)",
    smallscreen: {
      transform: "translate(-50%, -170%)",
    },
  },
  header: {
    fontSize: "xx-large",
    fontFamily: "Helvetica Neue,Helvetica,Arial,sans-serif",
    lineHeight: "normal",
    smallscreen: {
      fontSize: "xxx-large",
    },
  },
  subheader: {
    display: "none",
    smallscreen: {
      display: "block",
      fontSize: "x-large",
      fontWeight: 500,
    },
  },
};

export const lpFlightsSearchFormStyles = {
  flightsSearchForm: {},
  inputGroupField: {
    placeholder: {
      color: jssVariables.colors.border,
    },
    control: {
      borderRadius: 0,
      borderColor: "white!important",
    },

    paxBtn: {
      borderRadius: 0,
      borderColor: "white!important",
    },
    reactSelectControl: {
      borderRadius: 0,
      borderColor: "white!important",
    },
    datepicker: {
      borderRadius: 0,
      borderColor: "white!important",
    },
  },
};

export const actMainSearchFormStyles = {
  activitySearchForm: {
    paddingTop: 0,
    smallscreen: {
      padding: 0,
    },
  },
  inputGroupField: {
    placeholder: {
      color: jssVariables.colors.border,
    },
    control: {
      borderRadius: 0,
      borderColor: "white!important",
      height: "3rem",
    },

    paxBtn: {
      borderRadius: 0,
      border: "1px solid white",
    },
    reactSelectControl: {
      borderRadius: 0,
      borderColor: "white!important",
    },
    datepicker: {
      borderRadius: 0,
      border: "1px solid white",
    },
  },
};

export const lpInfoBanner = {
  infoBannerContainer: {
    margin: [jssVariables.navbar_height, 0],
    smallscreen: {},
  },
  header: {
    fontSize: "small",
    smallscreen: {
      fontSize: "medium",
      fontWeight: 500,
    },
  },
};

export const partnersBanner = {
  header: {
    fontSize: "large",
    fontWeight: "bold",
    color: "black",
    textTransform: "capitalize",
    smallscreen: {
      fontSize: "xx-large",
      fontWeight: 800,
    },
  },
  logos: {
    smallscreen: {
      gridTemplateColumns: "repeat(7, max-content)",
      alignItems: "center",
    },
  },
};

export const mainPromoStyles = {
  header: {
    color: "black",
    fontWeight: 800,
    fontSize: "xx-large",
  },
};

export const GeneralCards = {
  header: {
    fontWeight: 800,
  },
};
